<template>
    <div class="compare">
        <div class="container compare__container">
            <a class="compare__back-btn" :href="kadraGlobal.Url + '/shop'">Back to Products</a>
            <h2 class="section-title compare__title">Compare</h2>

            <div class="compare__wrapper">
                <SvgIcon class="compare__wrapper-icon" iconName="ico-hand" />
                <div class="compare__categories">
                    <div class="compare__categories-top"></div>
                    <div class="compare__categories-title-wrapper" v-if="anyProductHasValue('brand')">
                        <span class="compare__categories-title compare__categories-title--brand">Brand</span>
                    </div>
                    <div
                        class="compare__categories-title-wrapper compare__categories-title-wrapper--title js-compare__categories-title-wrapper--title">
                        <span class="compare__categories-title compare__categories-title--title">Title</span>
                    </div>
                    <div class="compare__categories-title-wrapper" v-if="anyProductHasValue('size')">
                        <span class="compare__categories-title">Size</span>
                    </div>
                    <div class="compare__categories-title-wrapper" v-if="anyProductHasValue('color')">
                        <span class="compare__categories-title">Color</span>
                    </div>
                    <div class="compare__categories-title-wrapper">
                        <span class="compare__categories-title">Case pack</span>
                    </div>
                    <div class="compare__categories-title-wrapper" v-if="anyProductHasValue('sku')">
                        <span class="compare__categories-title">Sku</span>
                    </div>
                    <div class="compare__categories-title-wrapper compare__categories-title-wrapper--details js-compare__categories-title-wrapper--details"
                        v-if="anyProductHasValue('description')">
                        <span class="compare__categories-title compare__categories-title--details">Additional Product
                            Details</span>
                    </div>
                    <div class="compare__categories-bottom" v-if="kadraGlobal.userId !== '0'"></div>
                </div>
                <div class="compare__items-wrapper">
                    <div class="compare__items-item" v-for="(product, index) in products" :key="product.ID">
                        <div class="compare__items-item-img media-wrap--lazy-loader" ref="productImageWrapRef">
                            <img class="lazy compare__items-item-img-photo" @load="onImageLoaded" :src="
                                product.image ||
                                kadraGlobal.icons +
                                '/src/assets/images/plch.jpg'
                            " alt="Product Image" />
                        </div>
                        <div class="compare__items-item-wrapper" v-if="anyProductHasValue('brand')">
                            <span v-if="product.pa_brand" class="compare__items-item-brand"
                                v-html="product.pa_brand"></span>
                            <span v-else class="compare__items-item-brand">
                                /
                            </span>
                        </div>
                        <div
                            class="compare__items-item-wrapper compare__items-item-wrapper--title js-compare__categories-title-wrapper--title">
                            <a :href="
                                kadraGlobal.Url + '/product/' + product.slug
                            ">
                                <span class="compare__items-item-title" v-html="product.title"></span>
                            </a>
                        </div>
                        <div class="compare__items-item-wrapper" v-if="anyProductHasValue('size')">
                            <span v-if="product.size" class="compare__items-item-size" v-html="product.size"></span>
                            <span v-else class="compare__items-item-size">
                                /
                            </span>
                        </div>
                        <div class="compare__items-item-wrapper" v-if="anyProductHasValue('color')">
                            <span v-if="product.color" class="compare__items-item-color" v-html="product.color"></span>
                            <span v-else class="compare__items-item-color">
                                /
                            </span>
                        </div>
                        <div class="compare__items-item-wrapper">
                            <span v-if="product.pack" class="compare__items-item-pack" v-html="product.pack"></span>
                            <span v-else class="compare__items-item-pack">
                                /
                            </span>
                        </div>
                        <div class="compare__items-item-wrapper" v-if="anyProductHasValue('sku')">
                            <span v-if="product.sku" class="compare__items-item-sku" v-html="product.sku"></span>
                            <span v-else class="compare__items-item-sku">
                                /
                            </span>
                        </div>
                        <div class="compare__items-item-wrapper compare__items-item-wrapper--list js-compare__categories-title-wrapper--details"
                            v-if="anyProductHasValue('description')"
                        >
                            <ul class="compare__items-item-details-list" v-if="product.description">
                                <li v-for="(item, index) in product.description.split(',')" :key="index" v-html="item"
                                    class="compare__items-item-details-list-item"
                                ></li>
                            </ul>
                            <span v-else> / </span>
                        </div>
                        <div class="compare__items-item-total-wrapper" v-if="kadraGlobal.userId !== '0'">
                            <div class="compare__items-item-total-price-wrapper">
                                <span v-if="product.price !== product.priceR" class="compare__items-item-total-price compare__items-item-total-price--sale" style="text-decoration:line-through">
                                    <span>$</span>{{ product.priceR }}
                                </span>
                                <span class="compare__items-item-total-price">
                                    <sup>$</sup>{{ product.price }}
                                </span>
                                <span class="compare__items-item-total-price-unit">/unit</span>
                            </div>
                            <div v-if="userType === 'salesman'" class="salesman-notification-wrap">
                                <span class="salesman-notification">Please select a customer.</span>
                            </div>
                            <div v-else class="compare__items-item-total-quantity-wrapper">
                                <div class="compare__items-item-total-quantity-contaner">
                                    <span
                                        class="compare__items-item-total-quantity-toggle compare__items-item-total-quantity--minus js-input-increment-minus"
                                        @click="removeFromCart(product.id, index, product.pack)">
                                    </span>
                                    <input
                                    class="compare__items-item-total-quantity-contaner-input"
                                    v-if="cart[product.id]"
                                    type="text"
                                    ref="inputQy"
                                    min="0"
                                    maxlength="5"
                                    v-model="CartQty[product.id]"
                                    @input="updateValue($event, product)"
                                    v-on:keyup="onEnter(product.id, '', product.pack, index)"
                                    @focus="onFocus"
                                    @blur="onBlur"
                                    placeholder="0" />

                                    <input v-else
                                    class="compare__items-item-total-quantity-contaner-input"
                                    type="text"
                                    ref="inputQy"
                                    min="0"
                                    maxlength="5"
                                    v-model="CartQty[product.id]"
                                    @input="updateValue($event, product)"
                                    value="0"
                                    v-on:keyup="onEnter(product.id, '', product.pack, index)"
                                    @focus="onFocus"
                                    @blur="onBlur"
                                    placeholder="0" />
                                    <span
                                        class="compare__items-item-total-quantity-toggle compare__items-item-total-quantity--plus js-input-increment-plus"
                                        @click="addToCart(product.id, index, product.pack)">
                                    </span>
                                </div>
                                <template v-if="activeIndex2 !== index">
                                    <span v-if="cart[product.id]"
                                        class="cart__items-item-quantity-cases cart__items-item-quantity-cases--has-item">Units
                                        in cart</span>
                                    <span v-else class="product-info-box__total-cases">Units in cart</span>
                                </template>
                                <span v-if="activeIndex2 === index"
                                    class="product-info-box__total-quantity-loader">Processing...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- .compare -->
</template>

<script>
import { mapState } from 'vuex';
import SvgIcon from '../../base/SvgIcon/SvgIcon.vue';

export default {
    computed: mapState({
        addToCartLoading: state => state.Cart.addToCartLoading,
        cart: state => state.Cart.cart
    }),
    components: {
        SvgIcon
    },
    data() {
        return {
            products: [],
            kadraGlobal: kadraGlobal,
            userType: window.usingcustomer.session.type,
            activeIndex2: undefined,
            inputDelay: null,
            timeouts: {},
            delayTime: 1000,
            imageLoaded: false,
            CartQty: {}
        };
    },
    watch: {
        addToCartLoading() {
            if (!this.addToCartLoading) {
                this.activeIndex2 = undefined;
            }
        },
        imageLoaded() {
            if(this.imageLoaded) {
                const wrappers = this.$refs.productImageWrapRef;
                console.log(wrappers);
                for (let i = 0; i < wrappers.length; i++) {
                    const element = wrappers[i];
                    console.log(element);
                    element.classList.remove('media-wrap--lazy-loader');
                }
            }
        },
        cart() {
            this.CartQty= { ...this.cart };
        },
    },

    methods: {
        onImageLoaded() {
            this.imageLoaded = true;
        },
        onFocus(event) {
        // Add the is-focused class to the input when it is focused
        event.target.classList.add('is-focused');

        // Clear the value if it's 0 (acts as a placeholder)
        if (event.target.value === '0') {
            event.target.value = '';
        }
        },
        onBlur(event) {
            // Remove the is-focused class when the input loses focus
            event.target.classList.remove('is-focused');

            // Reset the value back to 0 if it's empty
            if (event.target.value === '') {
                event.target.value = '0';
            }
        },
        updateValue(event, product) {
            let val = event.target.value;
            const max = event.target.maxLength;

            // Replace non-numeric characters
            val = val.replace(/[^0-9]/g, '');

            if (val.length > max) {
                val = val.slice(0, max);
            }

            // Ensure CartQty is initialized
            if (!this.CartQty) {
                this.CartQty = {}; // Initialize CartQty if undefined
            }

            // Update the CartQty object with the new value
            this.CartQty[product.id] = parseInt(val) || 0;

            // Set the sanitized value in the input field
            event.target.value = val;
        },
        setCompare() {
            const products = localStorage.getItem(
                'compare-' + this.kadraGlobal.userId
            );
            products === null
                ? (window.location.href = kadraGlobal.Url + '/shop')
                : (this.products = JSON.parse(products));
            this.getCartInfo();
        },
        anyProductHasValue(key) {
            let found = false;
            this.products.forEach(p => {
                found = found || !!p[key];
            });
            return found;
        },
        getCartInfo() {
            const obj = {
                ids: []
            };
            this.products.forEach(element => {
                obj.ids.push(element.id);
            });
            this.$store.dispatch('getCartById', obj);
        },
        addToCart(id, index, pack) {
            // Ensure CartQty is set correctly when adding
            const newQuantity = (this.CartQty[id] || 0) + 1;
            this.CartQty[id] = newQuantity;

            clearTimeout(this.timeouts[id]);
            this.timeouts[id] = setTimeout(() => {
                this.activeIndex2 = index;

                // Dispatch cart update action
                this.$store.dispatch('addMany', {
                    id: id,
                    val: newQuantity,
                    pack: pack
                });

                if (!this.addToCartLoading && this.activeIndex2 === index) {
                    this.activeIndex2 = undefined;
                }
            }, this.delayTime);
        },
        removeFromCart(id, index, pack) {
            // Ensure CartQty does not go below 0
            if (this.CartQty[id] > 0) {
                this.CartQty[id] = this.CartQty[id] - 1;
            }

            // Dispatch cart update action
            this.$store.dispatch('minusManyFromCart', {
                id: id
            });

            clearTimeout(this.timeouts[id]);
            this.timeouts[id] = setTimeout(() => {
                if (!this.addToCartLoading) {
                    this.activeIndex2 = index;
                }
                this.$store.dispatch('addMany', {
                    id: id,
                    val: this.CartQty[id],
                    pack: pack
                });
            }, this.delayTime);
        },
        checkCart(product) {
            if (product.inStock === '' || product.inStock === null) {
                return true;
            }

            if (product.inStock === 0) {
                return false;
            }

            /* eslint-disable */
            if (this.cart.hasOwnProperty(parseInt(product.id))) {
                const inCartQty = this.cart[parseInt(product.id)];
                let max = parseInt(product.inStock) / parseInt(product.pack);
                max = Math.floor(max);
                if (inCartQty < max) {
                    return true;
                } else {
                    return false;
                }
            } else {
                let max = parseInt(product.inStock) / parseInt(product.pack);
                max = Math.floor(max);
                if (max < 1) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        onEnter(id, qty, pack, index) {
            let val = parseInt(event.target.value);
            if (isNaN(val) || val <= 0) {
                // prevent negative and literals
                val = 0;
                event.target.value = val;
            }
            if (qty === '') {
                clearTimeout(this.inputDelay);
                this.inputDelay = setTimeout(() => {
                    this.activeIndex2 = index;
                    const obj = {
                        id: id,
                        val: val,
                        pack: pack
                    };
                    this.$store.dispatch('addMany', obj);
                }, 500);
            } else {
                const check = val * parseInt(pack);
                if (check > parseInt(qty)) {
                    // val = qty / pack;
                    // val = Math.floor(val);
                    event.target.value = val;
                }
                clearTimeout(this.inputDelay);
                this.inputDelay = setTimeout(() => {
                    this.activeIndex2 = index;
                    const obj = {
                        id: id,
                        val: val,
                        pack: pack
                    };
                    this.$store.dispatch('addMany', obj);
                }, 500);
            }
        },
        /**
         * @description add equal height to products
         */
        equalHeights: elName => {
            setTimeout(() => {
                const products = document.getElementsByClassName(elName);
                let x = 0;

                Array.from(products).forEach(el => {
                    el.style.height = 'auto';
                    if (el.offsetHeight > x) {
                        x = el.offsetHeight;
                    }
                });

                Array.from(products).forEach(el => {
                    el.style.height = `${x}px`;
                });
            }, 100);
        }
    },

    beforeMount() {
        this.setCompare();
    },

    mounted() {
        this.equalHeights('js-compare__categories-title-wrapper--title');
        this.equalHeights('js-compare__categories-title-wrapper--details');
        this.equalHeights('compare__items-item-total-wrapper');
    },
};
</script>

<style lang="scss" scoped>
.salesman-notification-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
}

.compare__wrapper-icon {
    display: none;

    @include mq($md) {
        display: block;
    }
}

.product-info-box__total-quantity-out {
    width: 50%;
    padding: 25px 0 22px;

    @include mq($lg) {
        width: 100%;
    }
}

.compare__items-item-total-quantity-contaner {

    // sass-lint:disable no-vendor-prefixes
    @media all and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
        margin-bottom: 0;
    }
}

.cart__items-item-quantity-cases--has-item {
    margin-top: 0px;

    // sass-lint:disable no-vendor-prefixes
    @media all and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
        padding-left: 13px;

        &::after {
            left: 0;
        }
    }
}

.compare__items-item-img.media-wrap--lazy-loader {
    position: relative;
    overflow: hidden;
}

.compare__items-item-total-price--sale {
    font-size: 11px;
    font-weight: 400;
    font-family: $font-main;
    margin-bottom: 2px;
    display: block;
}

.compare__items-item-total-quantity-contaner-input {
    &::placeholder {
        color: $white;
    }
}

.is-focused {
    &::placeholder {
        color: transparent !important;
    }
}
</style>
